import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material'
import { styled } from '@mui/material/styles'
import SearchIcon from '@mui/icons-material/Search'
import useStoreLocatorContext from '@context/storeLocatorContext/useStoreLocatorContext'

const SearchButton = styled(Button)(() => ({
  zIndex: 10,
  position: 'absolute',
  left: 0,
  right: 0,
  top: 16,
  display: 'flex',
  alignItems: 'center',
  borderRadius: 1000,
  margin: '0 auto',
  width: 'fit-content',
  backgroundColor: 'white',
  padding: '4px 8px',
  fontSize: '14px',
  fontWeight: 600,
  '&:hover': {
    backgroundColor: '#F2F6FA',
  },
  '&:focus': {
    backgroundColor: '#F2F6FA',
  },
}))

const SearchIconWrapper = styled(SearchIcon)(() => ({ width: '16px', height: '16px', marginRight: '4px' }))

const RadarSearchAreaButton = () => {
  const [showButton, setShowButton] = useState(false)
  const mapInstance = useStoreLocatorContext(state => state.mapInstance)
  const currentPosition = useStoreLocatorContext(state => state.currentPosition)
  const setCurrentPosition = useStoreLocatorContext(state => state.setCurrentPosition)
  const setSearchedLocation = useStoreLocatorContext(state => state.setSearchedLocation)

  const handleMove = map => {
    // We only want to show the button when the user has zoomed in enough.
    if (map && map.getZoom() > 7) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  // After first loading the map or searching a location, this button is not shown.
  // We want to display the button after the user has either dragged or zoomed the map.
  useEffect(() => {
    if (mapInstance) {
      mapInstance?.on('zoomend', () => handleMove(mapInstance))
      mapInstance?.on('dragend', () => handleMove(mapInstance))
    }
    return () => {
      if (mapInstance) {
        mapInstance?.off('zoomend', () => handleMove(mapInstance))
        mapInstance?.off('dragend', () => handleMove(mapInstance))
      }
    }
  }, [mapInstance])

  // When the user has entered a search query and the map is at a new 'currentPosition',
  // we want to initially hide the button.
  useEffect(() => {
    if (showButton && currentPosition) {
      setShowButton(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPosition])

  const handleClick = () => {
    const location = mapInstance.getCenter()
    if (location?.lat) {
      setSearchedLocation(location)
      setCurrentPosition({ lat: location.lat, lng: location.lng })
      setShowButton(false)
    }
  }

  if (!showButton) return null

  return (
    <SearchButton variant="outlined" onClick={handleClick}>
      <SearchIconWrapper />
      SEARCH THIS AREA
    </SearchButton>
  )
}

export default RadarSearchAreaButton
